module.exports = __webpack_public_path__ + "img/neg-y.ab036426.png";